import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root"); // Adjust according to your app's root element

const ModalPreview = ({
  isOpen,
  onRequestClose,
  base64Pdf,
  handleCreateReport
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    style={{
      content: {
        inset: "50% auto auto 55%",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "60%",
        height: "90%"
      }
    }}
  >
    <h2>Rapor Önizleme</h2>
    <iframe
      width="100%"
      height="80%"
      src={base64Pdf}
      title="Rapor Önizleme"
      frameBorder="0"
    />
    <div className="mt-4 flex justify-end space-x-4">
      <button
        onClick={onRequestClose}
        className="mb-5 ml-4 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
      >
        Kapat
      </button>
      <button
        onClick={handleCreateReport}
        className="mb-5 py-3 px-4 inline-flex justify-center text-white items-center gap-2 rounded-md border border-transparent font-semibold bg-[#09C35C] text-white hover:bg-[#0adf6a] text-sm"
      >
        Raporu Tamamla
      </button>
    </div>
  </Modal>
);

export default ModalPreview;
